module.exports = __webpack_public_path__ + "static/media/logo-name.6c919fb0.svg";